import { initialValuesRealState as initialValues } from '../../../../../../helpers/variablesInitialValues';
import * as types from '../types/realStateType';

const initialState = {
	perPage: 10,
	page: 1,
	pages: 1,
	search: '',
	arrayList: [],
	arrayListToDropdown: [],
	refreshTable: false,
	isOpenModal: false,
	isOpenModalPermission: false,
	isLoadingShow: false,
	isLoadingForm: false,
	formType: '',
	formData: initialValues
};

const realStateReducer = (state = initialState, { type, payload }) => {
	switch (type) {
		case types.PER_PAGE_REALSTATE:
			return {
				...state,
				perPage: payload
			};
		
		case types.PAGE_REALSTATE:
			return {
				...state,
				page: payload
			};
		
		case types.PAGES_REALSTATE:
			return {
				...state,
				pages: payload
			};
		
		case types.SEARCH_REALSTATE:
			return {
				...state,
				search: payload
			};
		
		case types.ARRAY_LIST_REALSTATE:
			return {
				...state,
				arrayList: payload
			};
		
		case types.ARRAY_LIST_TO_DROPDOWN_REALSTATE:
			return {
				...state,
				arrayListToDropdown: payload
			};
		
		case types.REFRESH_TABLE_REALSTATE:
			return {
				...state,
				refreshTable: payload
			};
		
		case types.IS_OPEN_MODAL_REALSTATE:
			return {
				...state,
				isOpenModal: payload
			};
		
		case types.IS_LOADING_SHOW_REALSTATE:
			return {
				...state,
				isLoadingShow: payload
			};
		
		case types.IS_LOADING_FORM_REALSTATE:
			return {
				...state,
				isLoadingForm: payload
			};
		
		case types.FORM_TYPE_REALSTATE:
			return {
				...state,
				formType: payload
			};
		
		case types.FORM_DATA_REALSTATE:
			return {
				...state,
				formData: payload
			};
		
		default:
			return state
	}
};

export default realStateReducer;
